import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react'
import { KTSVG } from '../../../_metronic/helpers';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import * as yup from 'yup';
import { Formik } from 'formik';
import fetchAPI from "../../../common/fetchAPI";
import { ShowToast } from '../../../common/Toastr';
import Select, { StylesConfig } from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { DateRangePicker } from 'rsuite';
import { format } from 'date-fns';
import { dropDownSelectionStyles, dateFormatByAccountCulture, normalizeDateFormat, getValueFromResource, dateFormatByAccountCultureForFilters } from '../../../common/timeLiveFunction';
import { t } from "i18next";
import MyTask from './MyTask';
import { updateMyTaskFilters } from '../TaskSlice';
import DatePickerRanges from '../../../common/DatePickerRanges';
import fetchTimeliveAPI from '../../../common/fetchTimeliveAPI';



const TaskFilters = (props: any) => {
    const { modelRef } = props;

    const { maxMenuHeight, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat } = useAppSelector(state => state.globalState);
    const { startDate, endDate } = useAppSelector((state) => state.task);

    const dispatch = useAppDispatch();
    const [isChecked, setIsChecked] = useState(false);
    const [selectedOptionProject, setSelectedOptionProject] = useState<{ [object: string]: any }>();
    const [ProjectArray, setProjectArray] = useState<any | ''>([]);
    const [selectedOptionTaskType, setSelectedOptionTaskType] = useState<{ [object: string]: any }>();
    const [TaskTypeArray, setTaskTypeArray] = useState<any | ''>([]);
    const [selectedOptionMilestone, setSelectedOptionMilestone] = useState<{ [object: string]: any }>();
    const [MilestoneArray, setMilestoneArray] = useState<any | ''>([]);
    // const [selectedOptionStatus, setSelectedOptionStatus] = useState<{ [object: string]: any }>();
    const [selectedOptionStatus, setSelectedOptionStatus] = useState<any[]>([]);
    const [StatusArray, setStatusArray] = useState<any | ''>([]);
    const currentDate = new Date();
    const [SelectedStartDate, setSelectedStartDate] = useState(currentDate);
    const [SelectedEndDate, setSelectedEndDate] = useState(currentDate);
    const [selectedOptionCompleteStatus, setSelectedOptionCompleteStatus] = useState({ label: 'All', value: -1 });
    const [displayedRange, setDisplayedRange] = useState('Please Select Date Range');
    const [selectedDescription, setselectedDecription] = useState('');
    const [priorityOptions, setPriorityOptions] = useState<any[]>([])
    const [selectedPriority, setSelectedPriority] = useState<any>();
    const CompletedStatusOptions = [
        { label: 'All', value: -1 },
        { label: t('Completed Tasks'), value: 1 },
        { label: t('Incomplete Tasks'), value: 0 }
    ];

    const ActiveInActiveOptions = useMemo(() => [
        { label: 'All', value: -1 },
        { label: getValueFromResource('Active', dispatch, t), value: 0 },
        { label: getValueFromResource('InActive', dispatch, t), value: 1 },
    ], [dispatch, t]);
    const [selectedOptionActive, setSelectedOptionActive] = useState(ActiveInActiveOptions[1])


    const getProjectsByAccountAsync = async () => {
        const response = await fetchAPI("api/V2/Projects/ProjectsByAccount", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        json.Data.map((item: any) => {
            item.value = item.AccountProjectId;
            item.label = item.ProjectName;
            delete item.AccountProjectId;
            delete item.ProjectName;
        });
        json.Data.unshift({ value: '0', label: 'All' })
        setProjectArray(json.Data);
    }



    const getTaskTypesByAccountAsync = async () => {
        const response = await fetchAPI("api/V2/Tasks/GetTaskTypeId", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        json.Data.map((item: any) => {
            item.value = item.AccountTaskTypeId;
            item.label = item.TaskType;
            delete item.AccountTaskTypeId;
            delete item.TaskType;
        });

        json.Data.unshift({ value: '0', label: 'All' })
        setTaskTypeArray(json.Data);
    }



    const getMilestoneByAccountAsync = async () => {
        const response = await fetchAPI("api/V2/Tasks/GetAccountProjectMilestonesByAccountProjectId", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        json.Data.map((item: any) => {
            item.value = item.AccountProjectMilestoneId;
            item.label = item.MilestoneDescription;
            delete item.AccountProjectMilestoneId;
            delete item.MilestoneDescription;
        });

        json.Data.unshift({ value: '0', label: 'All' })
        setMilestoneArray(json.Data);
    }

    const getAccountStatusAsync = async () => {
        const response = await fetchAPI("api/V2/Tasks/GetAccountsStatusForTask", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        json.Data.map((item: any) => {
            item.value = item.AccountStatusId;
            item.label = item.Status;
            delete item.AccountStatusId;
            delete item.Status;
        });

        json.Data.unshift({ value: '0', label: 'All' })
        setStatusArray(json.Data);
    }

    const getTaskPriority = async () => {
        try {
            const response = await fetchTimeliveAPI('api/Priority', `Get`, '', true);
            const json = await response.json();
            const options = json?.Data?.map((item: any) => ({
                label: item?.Priority,
                value: item?.AccountPriorityId
            }))
            options.unshift({ label: 'All', value: 0 });
            setPriorityOptions(options);
            setSelectedPriority(options[0]);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        getProjectsByAccountAsync();
        getTaskTypesByAccountAsync();
        getMilestoneByAccountAsync();
        getAccountStatusAsync();
        getTaskPriority();
    }, []);

    useEffect(() => {
        if (ProjectArray.length > 0) {
            setSelectedOptionProject(ProjectArray[0]);
        }
        if (TaskTypeArray.length > 0) {
            setSelectedOptionTaskType(TaskTypeArray[0]);
        }
        if (MilestoneArray.length > 0) {
            setSelectedOptionMilestone(MilestoneArray[0]);
        }
        if (StatusArray.length > 0) {
            setSelectedOptionStatus(StatusArray[0]);
        }
    }, [ProjectArray, TaskTypeArray, MilestoneArray, StatusArray]);

    useEffect(() => {
        if (TaskTypeArray.length > 0) {
            setSelectedOptionTaskType(TaskTypeArray[0]);
        }
    }, [TaskTypeArray]);

    useEffect(() => {
        if (StatusArray.length > 0) {
            setSelectedOptionStatus(StatusArray);
        }
    }, [StatusArray]);

    const closeButtonRef = useRef<HTMLButtonElement | null>(null);


    const handleSubmit = () => {
        const AccountProjectId = selectedOptionProject?.value || 0;
        const AccountTaskTypeId = selectedOptionTaskType?.value || 0;
        const AccountMilestoneId = selectedOptionMilestone?.value || 0;
        const AccountCompleteStatusId = selectedOptionCompleteStatus?.value;
        // const AccountStatusId = selectedOptionStatus?.value || 0;
        let AccountStatusId = '';
        if (selectedOptionStatus?.length > 0) {
            const hasAll = selectedOptionStatus.some((x: any) => x.value === '0');
            const finalValues = hasAll ? StatusArray.filter((x: any) => x.value !== '0').map((x: any) => x.value) : selectedOptionStatus.map((x: any) => x.value);
            AccountStatusId = finalValues.join(',');
        }
        const AccountPriorityId = selectedPriority?.value || 0;
        const StartDate = moment(SelectedStartDate).format(dateInsertionFormat);
        const EndDate = moment(SelectedEndDate).format(dateInsertionFormat);
        const Description = selectedDescription;
        const IncludeDateRange = isChecked;
        const IsDisabled = selectedOptionActive?.value

        const taskParams: any = {
            AccountProjectId,
            AccountTaskTypeId,
            AccountMilestoneId,
            AccountCompleteStatusId,
            AccountStatusId,
            AccountPriorityId,
            StartDate,
            EndDate,
            IncludeDateRange,
            Description,
            IsDisabled
        };
        dispatch(updateMyTaskFilters(taskParams));
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
    }

    // const handleCancel = () => {
    //     setSelectedOptionProject({ value: 0, label: 'All' });
    //     setSelectedOptionStatus({ value: 0, label: 'All' });
    //     setSelectedOptionTaskType({ value: 0, label: 'All' });
    //     setSelectedOptionMilestone({ value: 0, label: 'All' });

    //     console.log('TestCancel', )
    //     let CancelValues = `0,0,-1,0,0,,false,${moment(currentDate).format(dateInsertionFormat)},${moment(currentDate).format(dateInsertionFormat)}`;
    //     dispatch(updateMyTaskFilters(CancelValues));
    //     if (closeButtonRef.current) {
    //         closeButtonRef.current.click();
    //     }
    // }


    const handleChangeProject = (selectedOption: any) => {
        setSelectedOptionProject(selectedOption);
    };

    const handleChangeTaskType = (selectedOption: any) => {
        setSelectedOptionTaskType(selectedOption);
    };

    const handleChangeCompleteStatus = (selectedOption: any) => {
        setSelectedOptionCompleteStatus(selectedOption);
    };
    const handleChangeMilestone = (selectedOption: any) => {
        setSelectedOptionMilestone(selectedOption);
    };
    const handleChangeStatus = (selected: any) => {
        if (!selected) {
            setSelectedOptionStatus([]);
            return;
        }

        const hasAll = selected.some((x: any) => x.value === '0');

        if (hasAll) {
            setSelectedOptionStatus(StatusArray);
        } else {
            setSelectedOptionStatus(selected);
        }
    };
    const handleChangePriority = (selectedOption: any) => {
        setSelectedPriority(selectedOption);
    };
    // const handleChangeStatus = (selectedOption: any) => {
    //     setSelectedOptionStatus(selectedOption);
    // };    

    const handleCheckboxChange = (event: any) => {
        setIsChecked(event.target.checked);
    };

    const handleDateRangeChange = (value: any) => {
        if (value && value[0] && value[1]) {
            const formattedStartDate = format(value[0], CurrentCultureDateFormat.toString());
            const formattedEndDate = format(value[1], CurrentCultureDateFormat.toString());
            setDisplayedRange(`${formattedStartDate} - ${formattedEndDate}`);
        } else {
            setDisplayedRange('Please Select Date Range');
        }
        // setSelectedStartDate(dateFormatByAccountCulture(value[0].toISOString(), cultureInfoName.toString()));
        // setSelectedEndDate(dateFormatByAccountCulture(value[1].toISOString(), cultureInfoName.toString()));
        setSelectedStartDate(dateFormatByAccountCultureForFilters(format(value[0], "yyyy-MM-dd"), cultureInfoName.toString()));
        setSelectedEndDate(dateFormatByAccountCultureForFilters(format(value[1], "yyyy-MM-dd"), cultureInfoName.toString()));
    };

    const handleChangeActive = (selected: any) => {
        setSelectedOptionActive(selected);
        //setSelectedActive(selected);       
    };
    const customStyles = {
  valueContainer: (provided: any) => ({
    ...provided,
    display: "flex",
    flexWrap: "wrap",
    overflow: "hidden",
    maxHeight: "80px", // optional
  }),
  multiValue: (provided: any) => ({
    ...provided,
    maxWidth: "100%",
  }),
};
    return (
        <>
            <div className='card-body' style={{ overflowY: 'auto' }}>
                <div className='col-md-12'>

                    <div className='col-md-12'>
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Date Range')} */}
                            {getValueFromResource('Date Range', dispatch, t)}
                        </label>
                        <div>
                            <DateRangePicker
                                onChange={handleDateRangeChange}
                                ranges={DatePickerRanges()}
                                value={[SelectedStartDate, SelectedEndDate]}
                                // placeholder='Please Select Date Range'
                                placeholder={displayedRange}
                                character={' - '}
                                cleanable={false}
                                placement="bottomEnd"
                                format={normalizeDateFormat(CurrentCultureDateFormat.toString())}
                            ></DateRangePicker>
                        </div>
                    </div>
                </div>
                <div className='row spacingBetweenRows'>
                    <div className="col-md-12">
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Project Name')} */}
                            {getValueFromResource('Project Name', dispatch, t)}
                        </label>
                        <Select
                            value={selectedOptionProject}
                            id="AccountProjectId"
                            className="basic-single"
                            classNamePrefix="select"
                            isSearchable={true}
                            name="AccountProjectId"
                            onChange={handleChangeProject}
                            options={ProjectArray}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />
                    </div>
                </div>
                <div className='row spacingBetweenRows'>
                    <div className="col-md-12">
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Task Type')} */}
                            {getValueFromResource('Task Type', dispatch, t)}
                        </label>
                        <Select
                            value={selectedOptionTaskType}
                            className="basic-single"
                            classNamePrefix="select"
                            isSearchable={true}
                            name="AccountTaskTypeId"
                            onChange={handleChangeTaskType}
                            options={TaskTypeArray}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />
                    </div>
                </div>
                <div className='row spacingBetweenRows'>
                    <div className="col-md-12">
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Completed Status')} */}
                            {getValueFromResource('Completed Status', dispatch, t)}
                        </label>
                        <Select
                            value={selectedOptionCompleteStatus}
                            className="basic-single"
                            classNamePrefix="select"
                            isSearchable={true}
                            name="CompletedStatus"
                            onChange={handleChangeCompleteStatus}
                            options={CompletedStatusOptions}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />

                    </div>
                </div>
                <div className='row spacingBetweenRows'>
                    <div className="col-md-12">
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Milestone')} */}
                            {getValueFromResource('Milestone', dispatch, t)}
                        </label>
                        <Select
                            value={selectedOptionMilestone}
                            className="basic-single"
                            classNamePrefix="select"
                            isSearchable={true}
                            name="AccountProjectMilestoneId"
                            onChange={handleChangeMilestone}
                            options={MilestoneArray}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />

                    </div>
                </div>
                <div className='row spacingBetweenRows'>
                    <div className="col-md-12">
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Task Status')} */}
                            {getValueFromResource('Task Status', dispatch, t)}
                        </label>
                        <Select
                            value={selectedOptionStatus}
                            className="basic-single"
                            classNamePrefix="select"
                            isSearchable={true}
                            isMulti
                            name="AccountStatusId"
                            onChange={handleChangeStatus}
                            options={StatusArray}
                            styles={customStyles}
                            // styles={dropDownSelectionStyles}
                            // maxMenuHeight={maxMenuHeight}
                        />

                    </div>
                </div>
                <div className='row spacingBetweenRows'>
                    <div className="col-md-12">
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Task Status')} */}
                            {getValueFromResource('Task Priority', dispatch, t)}
                        </label>
                        <Select
                            value={selectedPriority}
                            className="basic-single"
                            classNamePrefix="select"
                            isSearchable={true}
                            name="AccountPriorityId"
                            onChange={handleChangePriority}
                            options={priorityOptions}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />

                    </div>
                </div>
                <div className='row spacingBetweenRows'>
                    <div className="col-md-12">
                        <label className="fs-7 fw-normal mb-2">
                            {getValueFromResource('Active /  InActive', dispatch, t)}
                        </label>
                        <Select
                            id="IsDisabled"
                            className="basic-single"
                            classNamePrefix="select"
                            isSearchable={true}
                            name="IsDisabled"
                            onChange={handleChangeActive}
                            options={ActiveInActiveOptions}
                            value={selectedOptionActive}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />

                    </div>
                </div>
                
                <div className='row spacingBetweenRows'>
                    <div className="col-md-12">
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Include Date Range')} */}
                            {getValueFromResource('Include Date Range', dispatch, t)}
                        </label>
                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                            <input
                                className="form-check-input h-20px w-30px mt-1"
                                type="checkbox"
                                style={{ marginTop: '-20px' }}
                                checked={isChecked}
                                onChange={handleCheckboxChange}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className='card-footer pt-4 '>
                <div className='d-flex flex-stack float-end'>
                    <button
                        ref={closeButtonRef}
                        type="button"
                        className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                        // id="kt_OffCanvas"
                        id='kt_OffCanvas_close'
                    // onClick={() => handleCancel()}
                    >
                        {/* {t('Cancel')}  */}
                        {getValueFromResource('Cancel', dispatch, t)}
                    </button>

                    <button
                        type="button"
                        data-kt-element='send'
                        className="btn btn-primary btn-sm fs-7"
                        onClick={() => handleSubmit()}
                    >
                        {/* {t('Apply Filters')} */}
                        {getValueFromResource('Apply Filters', dispatch, t)}
                    </button>

                </div>
            </div>
        </>

    )
}
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}
export default TaskFilters